<div class="page">
  <kendo-tabstrip  [keepTabContent]="true">
    <kendo-tabstrip-tab title="Skip Training" [selected]="true">
      <ng-template kendoTabContent>
        <kendo-expansionpanel title="Queries" [expanded]="true">
          <div>
            <kendo-grid
              mjFillContainer [fillHeight]="false" [fillWidth]="true"
              [kendoGridBinding]="AllQueryTrainingData"
              (edit)="editQueryHandler($event)"
              (remove)="removeQueryHandler($event)"
              (add)="addQueryHandler()"
              (selectionChange)="handleQuerySelectionChange($event)"
              [selectable]="true"
              [sortable]="true"
              [filterable]="true"
              (dblclick)="handleQueryDoubleClick($event)"
              [resizable]="true"
            >
              <ng-template kendoGridToolbarTemplate>
                <button kendoGridAddCommand><span class="fa-solid fa-plus"></span>New</button>
              </ng-template>
              <kendo-grid-column field="Connector" title="Connector" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="Name" title="Name" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="Description" title="Description" [sortable]="true" [filterable]="true" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.Description?.substring(0, 50) }}{{ dataItem.Description?.length > 50 ? '...' : '' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="SQLText" title="SQLText" [sortable]="true" [filterable]="true" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.SQLText?.substring(0, 50) }}{{ dataItem.SQLText?.length > 50 ? '...' : '' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column title="command" [width]="220">
                <ng-template kendoGridCellTemplate>
                  <button kendoGridEditCommand [primary]="true">Edit</button>
                  <button kendoGridRemoveCommand>Delete</button>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </kendo-expansionpanel>
        <kendo-expansionpanel title="Entity/Field Descriptions" [expanded]="true">
          <div>
            <kendo-grid
              mjFillContainer [fillHeight]="false" [fillWidth]="true"
              [kendoGridBinding]="AllEntityTrainingData"
              (edit)="editEntityHandler($event)"
              (remove)="removeEntityHandler($event)"
              (add)="addEntityHandler()"
              (selectionChange)="handleEntitySelectionChange($event)"
              [sortable]="true"
              [selectable]="true"
              [filterable]="true"
              (dblclick)="handleEntityDoubleClick($event)"
              [resizable]="true"
            >
              <ng-template kendoGridToolbarTemplate>
                <button kendoGridAddCommand><span class="fa-solid fa-plus"></span>New</button>
              </ng-template>
              <kendo-grid-column field="Connector" title="Connector" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="Type" title="Type" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="EntityName" title="Entity" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="FieldName" title="Field" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="Description" title="Description" [sortable]="true" [filterable]="true" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.Description?.substring(0, 50) }}{{ dataItem.Description?.length > 50 ? '...' : '' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="ScopeDefault" title="Scope Default" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="RowsToPackWithSchema" title="Entity: Rows To Pack With Schema" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="RowsToPackSampleMethod" title="Sample Method" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="RowsToPackSampleCount" title="Sample Count" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="RowsToPackSampleOrder" title="Sample Order" [sortable]="true" [filterable]="true" [width]="200"></kendo-grid-column>
              <kendo-grid-column field="AutoUpdateRelatedEntityInfo" title="Field: Auto Update Related Entity" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              <kendo-grid-column field="ValuesToPackWithSchema" title="Values To Pack" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
              
              <kendo-grid-command-column title="command" [width]="220">
                <ng-template kendoGridCellTemplate>
                  <button kendoGridEditCommand [primary]="true">Edit</button>
                  <button kendoGridRemoveCommand>Delete</button>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </kendo-expansionpanel>
      </ng-template>  
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Organizations">
      <ng-template kendoTabContent>
        <kendo-grid
          mjFillContainer [fillHeight]="false" [fillWidth]="true"
          [kendoGridBinding]="AllOrganizations"
          [sortable]="true"
          [filterable]="true"
        >
          <kendo-grid-column field="ID" title="ID" [sortable]="true" [filterable]="true"></kendo-grid-column>
          <kendo-grid-column field="Name" title="Name" [sortable]="true" [filterable]="true"></kendo-grid-column>
        </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Contacts">
      <ng-template kendoTabContent>
        <kendo-grid
          mjFillContainer [fillHeight]="false" [fillWidth]="true"
          [kendoGridBinding]="AllContacts"
          [sortable]="true"
          [filterable]="true"
          [resizable]="true"
        >
        <kendo-grid-column field="ID" title="ID" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="FirstName" title="FirstName" [sortable]="true" [filterable]="true" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="LastName" title="LastName" [sortable]="true" [filterable]="true" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="Email" title="Email" [sortable]="true" [filterable]="true" [width]="150"></kendo-grid-column>
      </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Instances">
      <ng-template kendoTabContent>
        <kendo-grid
          mjFillContainer [fillHeight]="false" [fillWidth]="true"
          [kendoGridBinding]="AllInstances"
          [sortable]="true"
          [filterable]="true"
          [resizable]="true"
          (cellClick)="handleInstanceClick($event)"
        >
          <kendo-grid-column field="ID" title="ID" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
          <kendo-grid-column field="Name" title="Name" [sortable]="true" [filterable]="true" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="Status" title="Status" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
          <kendo-grid-column field="Description" title="Description" [sortable]="true" [filterable]="true" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.Description?.substring(0, 50) }}{{ dataItem.Description?.length > 50 ? '...' : '' }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Connectors">
      <ng-template kendoTabContent>
        <kendo-grid
          mjFillContainer [fillHeight]="false" [fillWidth]="true"
          [kendoGridBinding]="AllConnectors"
          [sortable]="true"
          [filterable]="true"
          [resizable]="true"
        >
          <kendo-grid-column field="ID" title="ID" [sortable]="true" [filterable]="true" [width]="100"></kendo-grid-column>
          <kendo-grid-column field="Name" title="Name" [sortable]="true" [filterable]="true" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="Description" title="Description" [sortable]="true" [filterable]="true" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.Description?.substring(0, 50) }}{{ dataItem.Description?.length > 50 ? '...' : '' }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>


@if (showQueryEditor) {
  <kendo-dialog title="Query Editor" (close)="closeQueryEditor()">
    <div>
      <table> 
        <tr>
          <td>Connector:</td>
          <td><kendo-dropdownlist
            [data]="AllConnectors"
            textField="Name"
            valueField="ID"
            [(ngModel)]="editQueryTrainingDataItem_Connector">

          </kendo-dropdownlist></td>
        </tr>
        <tr>
          <td>Name:</td>
          <td><input kendoTextBox [(ngModel)]="editQueryTrainingDataItem.Name" /></td>
        </tr>
        <tr>
          <td>Description:</td>
          <td><textarea kendoTextBox [(ngModel)]="editQueryTrainingDataItem.Description" rows="10" cols="50"></textarea></td>
        </tr>
        <tr>
          <td>SQLText:</td>
          <td><textarea kendoTextBox [(ngModel)]="editQueryTrainingDataItem.SQLText" rows="10" cols="50"></textarea></td>
        </tr>
        <tr>
          <td></td>
          <td><button kendoButton (click)="saveQueryHandler()">Save</button>&nbsp;
              <button kendoButton (click)="closeQueryEditor()">Cancel</button></td>
        </tr>
      </table>
    </div>
  </kendo-dialog>
}

@if (showEntityEditor) {
  <kendo-dialog title="Entity/Field Editor" (close)="closeEntityEditor()">
    <div>
      <table> 
        <tr>
          <td>Connector:</td>
          <td><kendo-dropdownlist
            [data]="AllConnectors"
            textField="Name"
            valueField="ID"
            [(ngModel)]="editEntityTrainingDataItem_Connector">

          </kendo-dropdownlist></td>
        </tr>
        <tr>
          <td>Type:</td>
          <td><kendo-dropdownlist
            [data]="AllEntityTrainingDataTypes"
            [(ngModel)]="editEntityTrainingDataItem.Type"> 
          </kendo-dropdownlist></td>
        </tr>
        <tr>
          <td>Entity:</td>
          <td><input kendoTextBox [(ngModel)]="editEntityTrainingDataItem.EntityName" /></td>
        </tr>
        @if (editEntityTrainingDataItem.Type === 'Field') {
          <tr>
            <td>Field:</td>
            <td><input kendoTextBox [(ngModel)]="editEntityTrainingDataItem.FieldName" /></td>
          </tr>
        }
        <tr>
          <td>Description:</td>
          <td><textarea kendoTextBox [(ngModel)]="editEntityTrainingDataItem.Description" rows="5" cols="50"></textarea></td>
        </tr>
        <tr>
          <td>Scope Default:</td>
          <td>
            <kendo-multiselect
              [data]="AllEntityScopeDefaultOptions"
              [(ngModel)]="editEntityScopeDefaultOptions"
            ></kendo-multiselect>
          </td>
        </tr>
        @if (editEntityTrainingDataItem.Type === 'Entity') {
          <!-- entity stuff -->
          <tr>
            <td>Rows To Pack:</td>
            <td><kendo-dropdownlist
              [data]="AllEntityRowsToPackWithSchemaOptions"
              [(ngModel)]="editEntityTrainingDataItem.RowsToPackWithSchema"> 
            </kendo-dropdownlist></td>
          </tr>
          @if (editEntityTrainingDataItem.RowsToPackWithSchema === 'Sample') {
            <tr>
              <td>Sample Method:</td>
              <td><kendo-dropdownlist
                [data]="AllEntityRowsToPackSampleMethodOptions"
                [(ngModel)]="editEntityTrainingDataItem.RowsToPackSampleMethod"> 
              </kendo-dropdownlist></td>
            </tr>
            <tr>
              <td>Sample Count:</td>
              <td><input kendoTextBox [(ngModel)]="editEntityTrainingDataItem.RowsToPackSampleCount" /></td>
            </tr>  
            <tr>
              <td>Sample Order:</td>
              <td><textarea kendoTextBox [(ngModel)]="editEntityTrainingDataItem.RowsToPackSampleOrder" rows="5" cols="50"></textarea></td>
            </tr>
          }
        }
        @else {
          <!-- field stuff -->
          <tr>
            <td>Values To Pack:</td>
            <td><kendo-dropdownlist
              [data]="AllEntityValuesToPackOptions"
              [(ngModel)]="editEntityTrainingDataItem.ValuesToPackWithSchema"> 
            </kendo-dropdownlist></td>
          </tr>
          <tr>
            <td>Auto Update Related Entity Info:</td>
            <td><kendo-checkbox [(ngModel)]="editEntityTrainingDataItem.AutoUpdateRelatedEntityInfo"></kendo-checkbox></td>
          </tr>  
          @if (!editEntityTrainingDataItem.AutoUpdateRelatedEntityInfo) {
            <tr>
              <td>Related Entity:</td>
              <td><input kendoTextBox [(ngModel)]="editEntityTrainingDataItem.RelatedEntityName" /></td>
            </tr>  
            <tr>
              <td>Related Entity Field:</td>
              <td><input kendoTextBox [(ngModel)]="editEntityTrainingDataItem.RelatedEntityFieldName" /></td>
            </tr>  
          }
        }
        <tr>
          <td></td>
          <td><button kendoButton (click)="saveEntityHandler()">Save</button>&nbsp; 
              <button kendoButton (click)="closeEntityEditor()">Cancel</button></td>
        </tr>
      </table>
    </div>
  </kendo-dialog>
}

@if (showInstance) {
  <kendo-dialog title="Instance Details" (close)="closeInstance()">
    <div class="dialog-content">
      <div class="dialog-buttons">
        <button kendoButton class="inspect-btn" (click)="inspectInstance()">Inspect</button>
        <button kendoButton class="lock-btn" (click)="confirmAction('lock')">Lock</button>
        <button kendoButton class="unlock-btn" (click)="unlockInstance()">Unlock</button>
        <button kendoButton class="delete-btn" (click)="confirmAction('archive')">Archive</button>
      </div>
    </div>
  </kendo-dialog>
}

@if (showWarning) {
  <kendo-dialog title="Warning" (close)="closeWarning()">
    <p>Are you sure you want to {{ actionType === 'lock' ? 'lock' : 'archive' }} this instance?</p>
    <div class="dialog-buttons">
      <button kendoButton class="cancel-btn" (click)="closeWarning()">Cancel</button>
      <button kendoButton class="confirm-btn" (click)="executeAction()">{{ actionType === 'lock' ? 'Lock' : 'Delete' }}</button>
    </div>
  </kendo-dialog>
}
